import axiosMain from "../http/axiosMain";
import React, { useEffect, useState } from 'react';
import { Edit } from "lucide-react";
// import '../Assets/css/DashboardQueries.css';

const DashboardQueries = () => {
    const [contactData, setContactData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [editAssignRow, setEditAssignRow] = useState(null);
    const [assignToValue, setAssignToValue] = useState("");
    const [editReplyRow, setEditReplyRow] = useState(null); // New state for Reply modal
    const [replyValue, setReplyValue] = useState(""); // New state for Reply value

    // const userData = JSON.parse(localStorage.getItem('user'));
    // const userId = userData?.user?.user_id;
    const userId =JSON.parse(localStorage.getItem('user_id'));

    useEffect(() => {
        const fetchContactData = async () => {
            try {
                const response = await axiosMain.get(`api/contactus/getcontacts`, { params: { userId } });
                setContactData(response.data);
            } catch (err) {
                setError('Failed to load data');
            } finally {
                setLoading(false);
            }
        };

        fetchContactData();
    }, []);

    // Handle Modal Opening for Assign To
    const handleEditAssignClick = (index) => {
        setEditAssignRow(index);
        setAssignToValue(contactData[index].assign_to || "");
    };

    // Handle Modal Opening for Reply
    const handleEditReplyClick = (index) => {
        setEditReplyRow(index);
        setReplyValue(contactData[index].reply || ""); // Load existing reply or empty
    };

    // Handle Save for Assign To
    const handleModalSave = async () => {
        try {
            const updatedData = [...contactData];
            updatedData[editAssignRow].assign_to = assignToValue;
            setContactData(updatedData);

            // Make PUT request to backend with userId in params
            const contactId = contactData[editAssignRow].id;
            await axiosMain.put(
                `api/contactus/updatecontact/${contactId}`,
                {
                    assign_to: assignToValue,
                },
                {
                    params: { userId: userId }, // Pass userId as query parameter
                }
            );

            setEditAssignRow(null); // Close modal
        } catch (err) {
            setError("Failed to update Assign To");
        }
    };

    // Handle Save for Reply
    const handleReplySave = async () => {
        try {
            const updatedData = [...contactData];
            updatedData[editReplyRow].reply = replyValue;
            setContactData(updatedData);

            // Make PUT request to backend with userId in params
            const contactId = contactData[editReplyRow].id;
            await axiosMain.put(
                `api/contactus/updatecontact/${contactId}`,
                {
                    reply: replyValue,
                },
                {
                    params: { userId: userId }, // Pass userId as query parameter
                }
            );

            setEditReplyRow(null); // Close modal
        } catch (err) {
            setError("Failed to update Reply");
        }
    };



    if (loading) return <p>Loading...</p>;
    if (error) return <p>{error}</p>;

    return (
        <div className="dashboard-container1">
            {/* <h2>Contact Form Submissions</h2> */}
            <table className="dashboard-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Subject</th>
                        <th>Role</th>
                        <th>Message</th>
                        <th>Assign To</th>
                        <th>Reply</th>
                    </tr>
                </thead>
                <tbody>
                    {contactData.map((entry, index) => (
                        <tr key={index}>
                            <td>{entry.name}</td>
                            <td>{entry.email}</td>
                            <td>{entry.phone}</td>
                            <td>{entry.subject}</td>
                            <td>{entry.user_type}</td>
                            <td>{entry.message}</td>

                            {/* Assign To Column */}
                            <td className="editable-cell">
                                <div className="cl1">
                                    <p>{entry.assign_to || "Not Assigned"}</p>
                                    <button
                                        className="edit-btn1"
                                        onClick={() => handleEditAssignClick(index)}
                                    >
                                        <Edit className="h4 w-4" />
                                    </button>
                                </div>
                            </td>

                            {/* Reply Column - Use p tag instead of input */}
                            <td className="editable-cell">
                                <div className="cl2">
                                    <p>{entry.reply || "No reply"}</p> {/* Display Reply in p tag */}
                                    <button
                                        className="edit-btn1"
                                        onClick={() => handleEditReplyClick(index)}
                                    >
                                        <Edit className="h4 w-4" />
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Modal for Editing Assign To */}
            {editAssignRow !== null && (
                <div className="modal-overlay">
                    <div className="modal-content1">
                        <h3>Edit Assign To</h3>
                        <input
                            type="text"
                            value={assignToValue}
                            onChange={(e) => setAssignToValue(e.target.value)}
                            placeholder="Enter new value"
                        />
                        <div className="modal-actions">
                            <button onClick={handleModalSave} className="modal-save-btn">Save</button>
                            <button onClick={() => setEditAssignRow(null)} className="modal-cancel-btn">Cancel</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal for Editing Reply */}
            {editReplyRow !== null && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h3>Edit Reply</h3>
                        <textarea
                            value={replyValue}
                            onChange={(e) => setReplyValue(e.target.value)}
                            placeholder="Enter reply"
                            rows="4"
                            style={{ width: '100%' }}
                        />
                        <div className="modal-actions">
                            <button onClick={handleReplySave} className="modal-save-btn">Save</button>
                            <button onClick={() => setEditReplyRow(null)} className="modal-cancel-btn">Cancel</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DashboardQueries;
